/**
 * PostHog analytics — default autocapture handles clicks, pageviews, etc.
 * No custom events needed; PostHog tracks everything out of the box.
 */
import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_5ZGDNe27a0V18PKkZlJ4tkBfHL4CYhupFjjGmHO84ni';
/** PostHog's managed reverse proxy on our own domain, which ad blockers do not drop. */
const POSTHOG_HOST = 'https://v.everyferry.com';

export function initAnalytics(): void {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Behind a proxy, PostHog's links (the toolbar's) still point at PostHog
    ui_host: 'https://us.posthog.com',
    // PostHog's recommended settings as of that date: pageviews on every history change (a panel swap), page leaves
    defaults: '2026-05-30',
  });
}

if (typeof document !== 'undefined') {
  initAnalytics();
}
